// extracted by mini-css-extract-plugin
export default {"popupItem":"styles_popupItem__4ZUIO","item":"styles_item__A9wHk"};